import axiosClient from ".";
class ConversionRatesAPI {
  static get_conversion_rates() {
    return axiosClient.get("/api/v1/currency/conversion_rates");
  }
}
export default ConversionRatesAPI;
